import React from 'react';

interface SmartImagePreviewProps {
  src: string;
  alt: string;
  className?: string;
  imageClassName?: string;
  fit?: 'contain' | 'cover';
}

const SmartImagePreview: React.FC<SmartImagePreviewProps> = ({
  src,
  alt,
  className = '',
  imageClassName = '',
  fit = 'contain',
}) => (
  <div
    className={`relative overflow-hidden rounded-[24px] border border-white/10 bg-[linear-gradient(180deg,#fff7d8_0%,#f8ebc6_58%,#f4f0ea_58%,#ffffff_100%)] ${className}`.trim()}
  >
    <div className="absolute left-5 top-5 h-12 w-12 rounded-full bg-[#ef6f51]/18 blur-[1px]" />
    <div className="absolute right-5 top-10 h-7 w-7 rounded-full bg-[#e8b07f]/35" />
    <div className="absolute bottom-0 left-0 right-0 h-10 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.18),transparent_68%)] blur-xl" />
    <img
      src={src}
      alt={alt}
      className={`relative z-[1] h-full w-full ${fit === 'contain' ? 'object-contain p-4' : 'object-cover'} ${imageClassName}`.trim()}
      loading="lazy"
    />
  </div>
);

export default SmartImagePreview;
